<template>
  <v-dialog :value="show" persistent max-width="620" @input="$emit('close')">
    <v-card class="ec-card">
      <admin-table-subheader
        :title="application.company_name"
        close-button
        @close="$emit('close')"
      />

      <div class="pd-body">
        <table class="pd-table">
          <tr>
            <td class="pd-key">Status</td>
            <td class="pd-val">
              <span class="u-status-pill" :class="pillClass">{{ application.status }}</span>
            </td>
          </tr>
          <tr>
            <td class="pd-key">Contact</td>
            <td class="pd-val">{{ application.contact_name }}</td>
          </tr>
          <tr>
            <td class="pd-key">Email</td>
            <td class="pd-val">
              <a :href="`mailto:${application.email}`" class="pd-link">{{ application.email }}</a>
            </td>
          </tr>
          <tr v-if="application.phone">
            <td class="pd-key">Phone</td>
            <td class="pd-val">{{ application.phone }}</td>
          </tr>
          <tr v-if="application.country">
            <td class="pd-key">Country</td>
            <td class="pd-val">{{ application.country }}</td>
          </tr>
          <tr v-if="application.website">
            <td class="pd-key">Website</td>
            <td class="pd-val">
              <a :href="application.website" target="_blank" rel="noopener noreferrer" class="pd-link">
                {{ application.website }}
              </a>
            </td>
          </tr>
          <tr v-if="application.partner_type">
            <td class="pd-key">Partner type</td>
            <td class="pd-val">{{ application.partner_type }}</td>
          </tr>
          <tr>
            <td class="pd-key">Submitted</td>
            <td class="pd-val">{{ fmtDateTime(application.created_at) }}</td>
          </tr>
          <tr v-if="application.reviewed_at">
            <td class="pd-key">Reviewed</td>
            <td class="pd-val">{{ fmtDateTime(application.reviewed_at) }}</td>
          </tr>
          <tr v-if="application.reseller_id">
            <td class="pd-key">Reseller</td>
            <td class="pd-val">#{{ application.reseller_id }}</td>
          </tr>
        </table>

        <div v-if="application.message" class="pd-block">
          <p class="pd-block__title">Message</p>
          <p class="pd-block__text">{{ application.message }}</p>
        </div>

        <div v-if="application.review_note" class="pd-block">
          <p class="pd-block__title">Review note</p>
          <p class="pd-block__text">{{ application.review_note }}</p>
        </div>
      </div>

      <div class="pd-footer">
        <button class="ec-btn ec-btn--ghost" @click="$emit('close')">Close</button>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import AdminTableSubheader from '../shared/AdminTableSubheader.vue'

export default {
  name: 'PartnerApplicationDetail',
  components: { AdminTableSubheader },
  props: {
    show: { type: Boolean, default: false },
    application: { type: Object, required: true }
  },
  computed: {
    pillClass () {
      if (this.application.status === 'approved') return 'u-pill--green'
      if (this.application.status === 'rejected') return 'u-pill--red'
      return 'u-pill--amber'
    }
  },
  methods: {
    fmtDateTime (v) {
      if (!v) return '—'
      const d = new Date(v)
      return isNaN(d) ? v : d.toLocaleString()
    }
  }
}
</script>

<style scoped>
.pd-body { padding: 18px 20px; }
.pd-table { width: 100%; border-collapse: collapse; }
.pd-key {
  width: 34%;
  padding: 8px 12px;
  font-size: .78rem;
  font-weight: 600;
  color: var(--ec-text-2);
  background: var(--ec-gray-bg);
  border-bottom: 1px solid var(--ec-border);
}
.pd-val {
  padding: 8px 12px;
  font-size: .82rem;
  color: var(--ec-text-1);
  border-bottom: 1px solid var(--ec-border);
}
.pd-link { color: #0ea5e9; text-decoration: none; }
.pd-block {
  margin-top: 18px;
  padding: 14px;
  border: 1px solid var(--ec-border);
  border-radius: 8px;
  background: var(--ec-gray-bg);
}
.pd-block__title {
  margin: 0 0 6px;
  font-size: .72rem;
  font-weight: 700;
  letter-spacing: .5px;
  text-transform: uppercase;
  color: var(--ec-text-2);
}
.pd-block__text {
  margin: 0;
  font-size: .85rem;
  line-height: 1.65;
  color: var(--ec-text-1);
  white-space: pre-wrap;
}
.pd-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 12px 20px;
  border-top: 1px solid var(--ec-border);
}
</style>
